import { connect } from 'react-redux'

import CrowdfundingDetailView from 'components/crowdfunding_detail_view'
import { getNewCampaignSelector } from 'redux/selectors/campaign'
import { getCategoryDefaultCover, getMainCategory } from 'client/lib/category'

const mapStateToProps = (state, ownProps) => {
  const campaign = ownProps.isEdit
    ? ownProps.editedCampaign
    : getNewCampaignSelector(state, ownProps)
  const mainCategory = getMainCategory(campaign.category)
  const defaultCategoryCover = getCategoryDefaultCover(state, mainCategory)

  return {
    campaign,
    defaultCategoryCover,
    edit: ownProps.isEdit,
    geo: state.geo,
  }
}

export default connect(mapStateToProps)(CrowdfundingDetailView)
